import React from "react";

interface AvatarGroupProps {
    className?: string;
    children?: any;
    [x: string]: any;
}

export const AvatarGroup = ({
    className = null,
    children = null,
    ...props
}: AvatarGroupProps) => {
    return (
        <div className="avatar-group" {...props}>
            {children}
        </div>
    );
};
